import React from "react";
import Popup from "./Popup";
import { CamelCaseWithSpaces } from "../JS/Common";

export default function MultiErrorPopup({ isErrorShow, setErrorShow, modalSize = "lg", errorMsgs }) {

    const modalbody = (
        <>
            <h2 className="mb-3" style={{ fontWeight: 600 }}>{errorMsgs.message}</h2>
            <div className="p-3 greyBox" style={{ maxHeight: "300px", overflowY: 'auto' }}>
                {errorMsgs?.missingHeaders?.filter((msg) => msg?.trim() != "")?.length > 0 && (
                    <>
                        <strong className="redText">Missing Headers:</strong>
                        <ul className=" mb-3">
                            {errorMsgs.missingHeaders?.filter((msg) => msg?.trim() != "")?.map((msg) => (
                                <li>{CamelCaseWithSpaces(msg)}</li>
                            ))}
                        </ul>
                    </>
                )}

                {errorMsgs?.extraHeaders?.filter((msg) => msg?.trim() != "")?.length > 0 && (
                    <>
                        <strong className="redText">Extra Headers:</strong>
                        <ul className=" mb-3">
                            {errorMsgs.extraHeaders?.filter((msg) => msg?.trim() != "")?.map((msg) => (
                                <li>{CamelCaseWithSpaces(msg)}</li>
                            ))}
                        </ul>
                    </>
                )}

                {errorMsgs?.dataError && (
                    <>
                        <strong className="redText">Invalid Data:</strong>
                        <ul className=" mb-3">
                            <li>{errorMsgs?.dataError}</li>
                        </ul>
                    </>
                )}

                {errorMsgs?.errors && (
                    <>
                        <strong className="redText">Invalid Data:</strong>
                        <ul className=" mb-3">
                            {errorMsgs?.errors.map((item) => (
                                <li>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </>
                )}
                {errorMsgs?.emptyNormalizedHeaders && (
                    <>
                        <strong className="redText">Some rows have data without headers. Please check your CSV and ensure all data has proper column names.</strong>
                    </>
                )}
            </div>
            <div className="row pt-3">
                <label className="yellow-warning-text">We found some issues in the CSV you uploaded. Kindly review the errors listed, correct them, and re-upload the CSV.</label>
            </div>
        </>
    )

    return (
        <React.Fragment>
            <Popup
                isshow={isErrorShow}
                size={modalSize}
                title={"Imported CSV Errors"}
                closePopup={setErrorShow}
                modalBody={modalbody}
                visibleSaveBtn={false} />
        </React.Fragment>
    )
}